module.exports = "pegasus/assets/share-email.png";